import { render, staticRenderFns } from "./ForumChatThreadCardContent.vue?vue&type=template&id=753abb34&scoped=true"
import script from "./ForumChatThreadCardContent.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardContent.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardContent.vue?vue&type=style&index=0&id=753abb34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753abb34",
  null
  
)

export default component.exports